import React from 'react';

const ServicesSection = () => {
  // Data for all four sections
 const sections = [
  {
    title: 'SENIOR ELITE STYLIST',
    backgroundColor: '#FFFFFF',
    stylists: [
      {
        name: 'KAREN',
        title: 'SENIOR ELITE STYLIST',
        image: '/images/servicePage/Karen.webp',
        services: [
          { name: 'HAIRCUT | WOMEN', price: '$125+' },
          { name: 'WASH + BLOWOUT', price: '$80+' },
          { name: 'COLOR TOUCHUP', price: '$140+' },
          { name: 'FULL COLOR TRANSFORMATION', price: '$240+' },
          { name: 'CLASSIC HIGHLIGHT / BALAYAGE', price: '$325+' },
          { name: 'LUXE HIGHLIGHT / BALAYAGE', price: '$425+' },
          { name: 'VIVID TRANSFORMATION', price: 'PUC*', note: '*PRICE UPON CONSULTATION' },
          { name: 'BRAZILIAN BLOWOUT', price: '$425+' },
          { name: 'LUXURY EXTENSIONS', price: 'SINGLE STRAND FLAT TIP' },
          { name: 'LUXURY EXTENSIONS', price: 'WEFT, TAPE-INS' }
        ]
      }
    ],
    sideImages: [
      '/images/servicePage/karen_1.webp',
      '/images/servicePage/karen_2.webp'
    ]
  },
  {
    title: 'ELITE STYLIST',
    backgroundColor: '#FBF8F3',
    stylists: [
      {
        name: 'MACKENZIE',
        title: 'ELITE STYLIST',
        image: '/images/servicePage/Mackenzie.webp',
        services: [
          { name: 'HAIRCUT | WOMEN', price: '$95+' },
          { name: 'WASH + BLOWOUT', price: '$70+' },
          { name: 'COLOR TOUCHUP', price: '$130+' },
          { name: 'FULL COLOR TRANSFORMATION', price: '$230+' },
          { name: 'CLASSIC HIGHLIGHT / BALAYAGE', price: '$300+' },
          { name: 'LUXE HIGHLIGHT / BALAYAGE', price: '$400+' },
          { name: 'PLATINUM / BLEACH + TONE', price: 'PUC*', note: '*PRICE UPON CONSULTATION' },
          { name: 'VIVID TRANSFORMATION', price: 'PUC*' },
          { name: 'LUXURY EXTENSIONS', price: 'SINGLE STRAND FLAT TIP' },
          { name: 'LUXURY EXTENSIONS', price: 'TAPE IN' }
        ]
      },
      {
        name: 'JENA',
        title: 'ELITE STYLIST',
        image: '/images/servicePage/Jena.webp',
        services: [
          { name: 'HAIRCUT | WOMEN', price: '$90+' },
          { name: 'WASH + BLOWOUT', price: '$60+' },
          { name: 'COLOR TOUCHUP', price: '$130+' },
          { name: 'FULL COLOR TRANSFORMATION', price: '$230+' },
          { name: 'CLASSIC HIGHLIGHT / BALAYAGE', price: '$300+' },
          { name: 'LUXE HIGHLIGHT / BALAYAGE', price: '$400+' },
          { name: 'PLATINUM / BLEACH + TONE', price: 'PUC*', note: '*PRICE UPON CONSULTATION' },
          { name: 'VIVID TRANSFORMATION', price: 'PUC*' },
          { name: 'BRAZILIAN BLOWOUT', price: '$425+' },
          { name: 'LUXURY EXTENSIONS', price: 'TAPE-INS' },
          { name: 'LUXURY EXTENSIONS', price: 'WEFT, SINGLE STRAND' }
        ]
      }
    ],
    centerImage: '/images/servicePage/stylist_3.webp'
  },
  {
    title: 'MASTER STYLIST',
    backgroundColor: '#FFFFFF',
    stylists: [
      {
        name: 'ZHANA',
        title: 'MASTER STYLIST',
        image: '/images/servicePage/Zhana.webp',
        isCenter: true,
        services: [
          { name: 'HAIRCUT | WOMEN', price: '$70+' },
          { name: 'WASH + BLOWOUT', price: '$55+' },
          { name: 'COLOR TOUCHUP', price: '$125+' },
          { name: 'FULL COLOR TRANSFORMATION', price: '$225+' },
          { name: 'CLASSIC HIGHLIGHT / BALAYAGE', price: '$290+' },
          { name: 'LUXE HIGHLIGHT / BALAYAGE', price: '$390+' },
          { name: 'PLATINUM / BLEACH + TONE', price: 'PUC*', note: '*PRICE UPON CONSULTATION' },
          { name: 'VIVID TRANSFORMATION', price: 'PUC*' },
          { name: 'BRAZILIAN BLOWOUT', price: '$350+' },
          { name: 'LUXURY EXTENSIONS', price: 'SINGLE STRAND FLAT TIP' }
        ]
      }
    ],
    sideImages: [
      '/images/servicePage/stylist_12.webp',
      '/images/servicePage/stylist_13.webp'
    ]
  },
  {
    title: 'STYLIST',
    backgroundColor: '#FBF8F3',
    stylists: [
      {
        name: 'AMANDA',
        title: 'STYLIST',
        image: '/images/servicePage/Amanda.webp',
        isCenter: true,
        services: [
          { name: 'HAIRCUT | WOMEN', price: '$60+' },
          { name: 'WASH + BLOWOUT', price: '$40+' },
          { name: 'COLOR TOUCHUP', price: '$120+' },
          { name: 'FULL COLOR TRANSFORMATION', price: '$220+' },
          { name: 'CLASSIC HIGHLIGHT / BALAYAGE', price: '$280+' },
          { name: 'LUXE HIGHLIGHT / BALAYAGE', price: '$380+' },
          { name: 'VIVID TRANSFORMATION', price: 'PUC*', note: '*PRICE UPON CONSULTATION' },
          { name: 'BRAZILIAN BLOWOUT', price: '$325+' }
        ]
      }
    ],
    sideImages: [
      '/images/servicePage/stylist_5.webp',
      '/images/servicePage/stylist_6.webp'
    ]
  }
];

  const renderServices = (services, price) => {
    if (Array.isArray(services)) {
      const renderSideImagesSection = (section) => (
    <section
      className="py-8 sm:py-12 md:py-16 lg:py-20"
      style={{ backgroundColor: section.backgroundColor }}
    >
      <div className="container mx-auto px-4 max-w-7xl">
        <h3 className="text-center text-xl sm:text-2xl mb-8 sm:mb-12" style={{
          color: '#000',
          textAlign: 'center',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '100%',
          letterSpacing: '0.2em'
        }}>{section.title}</h3>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 xl:gap-16 justify-items-center items-start">
          {/* Left Image */}
          <div className="w-full flex justify-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[0]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
          </div>
          
          {/* Center Stylist */}
          <div className="w-full flex justify-center">
            {renderStylist(section.stylists[0])}
          </div>
          
          {/* Right Image with consultation note below */}
          <div className="w-full flex flex-col items-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[1]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
            
            <p className="mt-4 text-center" style={{
              color: '#C7A064',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>
              *PRICE UPON CONSULTATION
            </p>
          </div>
        </div>
      </div>
    </section>
  );

  return (
        <div className="w-full max-w-[360px]">
          {services.map((service, i) => (
            <div key={i} className="flex items-center justify-between mb-1 w-full">
              <span className="text-xs text-gray-600 whitespace-nowrap pr-2">{service}</span>
              <div className="flex-1 mx-2 h-[0.5px] bg-gray-400 min-w-[20px]"></div>
              <span className="text-amber-600 whitespace-nowrap pl-2 text-sm sm:text-base">{price[i]}</span>
            </div>
          ))}
        </div>
      );
    }
    const renderSideImagesSection = (section) => (
    <section
      className="py-8 sm:py-12 md:py-16 lg:py-20"
      style={{ backgroundColor: section.backgroundColor }}
    >
      <div className="container mx-auto px-4 max-w-7xl">
        <h3 className="text-center text-xl sm:text-2xl mb-8 sm:mb-12" style={{
          color: '#000',
          textAlign: 'center',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '100%',
          letterSpacing: '0.2em'
        }}>{section.title}</h3>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 xl:gap-16 justify-items-center items-start">
          {/* Left Image */}
          <div className="w-full flex justify-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[0]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
          </div>
          
          {/* Center Stylist */}
          <div className="w-full flex justify-center">
            {renderStylist(section.stylists[0])}
          </div>
          
          {/* Right Image with consultation note below */}
          <div className="w-full flex flex-col items-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[1]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
            
            <p className="mt-4 text-center" style={{
              color: '#C7A064',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>
              *PRICE UPON CONSULTATION
            </p>
          </div>
        </div>
      </div>
    </section>
  );

  return (
      <div className="flex items-center justify-between w-full max-w-[360px]">
        <span className="text-xs text-gray-600 whitespace-nowrap pr-2">{services}</span>
        <div className="flex-1 mx-2 h-[0.5px] bg-gray-400 min-w-[20px]"></div>
        <span className="text-amber-600 whitespace-nowrap pl-2 text-sm sm:text-base">{price}</span>
      </div>
    );
  };

  const renderStylist = (stylist) => (
  <div className="text-center w-full max-w-[400px]">
    <div className="mb-4 sm:mb-6">
      <img
        src={stylist.image}
        alt={stylist.name}
        className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 rounded-full mx-auto object-cover"
      />
    </div>
    <h4 className="text-xl sm:text-2xl font-semibold mb-2"
      style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {stylist.name}
    </h4>
    <p className="text-xs sm:text-sm text-gray-500 mb-4"
      style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.1em' }}>
      {stylist.title}
    </p>
    
    {/* Services List */}
    <div className="space-y-2 text-left">
      {stylist.services.map((service, index) => (
        <div key={index} className="flex items-center w-full">
          <span className="text-xs sm:text-sm text-gray-700 uppercase whitespace-nowrap"
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            {service.name}
          </span>
          <div className="flex-1 h-[1px] bg-[#D4D4D4] mx-2 min-w-[20px]"></div>
          <span className={`${service.price.startsWith('$') ? 'text-[#C7A064]' : 'text-[#C7A064]'} 
            text-xs sm:text-sm whitespace-nowrap`}
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            {service.price}
          </span>
        </div>
      ))}
    </div>
  </div>
);
  const renderSideImagesSection = (section) => (
    <section
      className="py-8 sm:py-12 md:py-16 lg:py-20"
      style={{ backgroundColor: section.backgroundColor }}
    >
      <div className="container mx-auto px-4 max-w-7xl">
        <h3 className="text-center text-xl sm:text-2xl mb-8 sm:mb-12" style={{
          color: '#000',
          textAlign: 'center',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '100%',
          letterSpacing: '0.2em'
        }}>{section.title}</h3>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 xl:gap-16 justify-items-center items-start">
          {/* Left Image */}
          <div className="w-full flex justify-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[0]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
          </div>
          
          {/* Center Stylist */}
          <div className="w-full flex justify-center">
            {renderStylist(section.stylists[0])}
          </div>
          
          {/* Right Image with consultation note below */}
          <div className="w-full flex flex-col items-center">
            <div className="w-full max-w-[511px]">
              <img
                src={section.sideImages[1]}
                alt="Stylist work showcase"
                className="w-full h-auto object-cover"
                style={{ aspectRatio: '511/766' }}
              />
            </div>
            
            <p className="mt-4 text-center" style={{
              color: '#C7A064',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
              letterSpacing: '0.8px',
              textTransform: 'uppercase'
            }}>
              *PRICE UPON CONSULTATION
            </p>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <>
      {/* Hero Section - FIXED RESPONSIVE */}
      <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-gray-50">
        <div className="relative px-4 sm:px-6 md:px-8" style={{ minHeight: '200px' }}>
          {/* Background "Prices" text - RESPONSIVE */}
          <div
            className="absolute inset-0 flex justify-center items-start pointer-events-none text-[#F2EADC] pt-4 sm:pt-8"
            style={{
              fontFamily: 'Quentin',
              fontSize: 'clamp(80px, 20vw, 160px)',
              fontWeight: '400',
              lineHeight: 'normal',
              fontStyle: 'normal'
            }}
          >
            Prices
          </div>
          {/* Main Header Text - RESPONSIVE */}
          <div className="relative z-10 text-center pt-20 sm:pt-28 md:pt-32">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-black mb-4 sm:mb-6 px-4">
              PROFESSIONAL HAIR SERVICES
            </h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-3xl mx-auto px-4">
              Explore our expert haircuts, color, and treatments with clear pricing-crafted to keep your
              style fresh and healthy.
            </p>
          </div>
        </div>
      </section>

      {/* GWEN SECTION - COMPLETELY REDESIGNED FOR MOBILE */}
{/* GWEN SECTION - COMPLETELY REDESIGNED FOR MOBILE */}
<section className="relative bg-black overflow-hidden">
  <div className="max-w-[1440px] mx-auto">
    <div className="flex flex-col lg:flex-row">
      {/* Left side - Image */}
      <div className="w-full lg:w-[45%] flex items-center justify-center bg-black p-4 sm:p-6 md:p-8 lg:p-12 xl:p-16">
        <div className="w-full max-w-[511px]">
          <img
            src="/images/servicePage/stylist_1.webp"
            alt="Gwen styling client"
            className="w-full h-auto object-cover"
            style={{ aspectRatio: '511/766' }}
          />
        </div>
      </div>
      
      {/* Right side - Content */}
      <div className="w-full lg:w-[55%] relative bg-black min-h-[400px] sm:min-h-[500px] lg:min-h-[600px]">
        {/* Damask Background - RESPONSIVE */}
        <div className="absolute z-0 inset-0 flex items-center justify-center opacity-10">
          <img
            src={require('../assets/images/White_damask.webp')}
            alt="Damask Background"
            className="w-[80%] max-w-[550px] h-auto object-contain"
          />
        </div>
        
        {/* Content - MOBILE FRIENDLY */}
        <div className="relative z-10 flex flex-col items-center lg:items-start justify-center h-full 
                      py-8 sm:py-12 lg:py-24 px-4 sm:px-6 lg:pl-16 xl:pl-20 lg:pr-8">
          
          {/* Profile Image */}
          <img 
            src="/images/servicePage/Gwen.webp" 
            alt="Gwen"
            className="w-32 h-32 sm:w-40 sm:h-40 md:w-44 md:h-44 lg:w-[160px] lg:h-[160px] 
                     xl:w-[200px] xl:h-[200px] rounded-full object-cover mb-4 sm:mb-6"
          />
          
          {/* Text Content */}
          <div className="w-full text-center lg:text-left">
            <h3 className="text-2xl sm:text-3xl lg:text-3xl xl:text-4xl font-bold text-white mb-1" 
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em'
                }}>
              GWEN
            </h3>
            <p className="text-xs sm:text-sm tracking-wider text-gray-400 mb-6 sm:mb-8 lg:mb-12" 
               style={{ 
                  fontFamily: 'Montserrat',
                   fontWeight: 400,
                   fontStyle: 'Regular',
                   fontSize: '12px',
                   color: '#f8f8f8ff',
                   letterSpacing: '.2em',
                   lineHeight: '100%'
               }}>
              OWNER & ARTISTIC DIRECTOR
            </p>
            
            <div className="w-full max-w-[600px] mx-auto lg:mx-0 space-y-3 sm:space-y-4">
              <div className="space-y-4">
                {/* HAIRCUT | WOMEN */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    HAIRCUT | WOMEN
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $150+
                  </span>
                </div>

                {/* HAIRCUT | MEN */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    HAIRCUT | MEN
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $60+
                  </span>
                </div>

                {/* WASH + BLOWOUT */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    WASH + BLOWOUT
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $90+
                  </span>
                </div>

                {/* COLOR TOUCHUP */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    COLOR TOUCHUP
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $160+
                  </span>
                </div>

                {/* FULL COLOR TRANSFORMATION */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    FULL COLOR
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $250+
                  </span>
                </div>

                {/* CLASSIC HIGHLIGHT / BALAYAGE */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    CLASSIC HIGHLIGHT / BALAYAGE
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $350+
                  </span>
                </div>

                {/* LUXE HIGHLIGHT / BALAYAGE */}
                <div className="flex items-center w-full">
                  <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    LUXE HIGHLIGHT / BALAYAGE
                  </span>
                  <div className="flex-1 h-[1px] bg-[#969696] mx-3 min-w-[20px] sm:min-w-[40px]"></div>
                  <span className="text-[#C7A064] text-base sm:text-lg whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    $450+
                  </span>
                </div>

                <div className="flex items-start w-full">
  <div className="flex-1 flex items-center">
    <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
      style={{ fontFamily: 'Montserrat, sans-serif' }}>
      VIVID TRANSFORMATION
    </span>
    <div className="flex-1 h-[1px] bg-[#969696] mx-2 sm:mx-3 min-w-[10px]"></div>
  </div>
  <span className="text-[#C7A064] text-[10px] sm:text-xs uppercase text-right max-w-[140px] sm:max-w-none"
    style={{ fontFamily: 'Montserrat, sans-serif', lineHeight: '1.2' }}>
    PRICE UPON CONSULTATION
  </span>
</div>

{/* LUXURY EXTENSION - Two Column Style */}
<div className="flex items-start w-full">
  <div className="flex-1 flex items-center">
    <span className="text-xs sm:text-sm text-gray-300 uppercase whitespace-nowrap"
      style={{ fontFamily: 'Montserrat, sans-serif' }}>
      LUXURY EXTENSION
    </span>
    <div className="flex-1 h-[1px] bg-[#969696] mx-2 sm:mx-3 min-w-[10px]"></div>
  </div>
  <span className="text-[#C7A064] text-[10px] sm:text-xs uppercase text-right max-w-[140px] sm:max-w-none"
    style={{ fontFamily: 'Montserrat, sans-serif', lineHeight: '1.2' }}>
    Single Strand Flat Tip, K-Tip, Tape-Ins
  </span>
</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* STYLIST SECTIONS - MOBILE FIRST APPROACH */}
      {/* STYLIST SECTIONS - MOBILE FIRST APPROACH */}
{/* SENIOR ELITE STYLIST - SIDE IMAGES LAYOUT (Karen only) */}
{renderSideImagesSection(sections[0])}

{sections.slice(1, 2).map((section, sectionIndex) => (
  <section
    key={sectionIndex}
    className="py-8 sm:py-12 md:py-16 lg:py-20"
    style={{ backgroundColor: section.backgroundColor }}
  >
    <div className="container mx-auto px-4 max-w-7xl">
      <h3 className="text-center text-xl sm:text-2xl mb-8 sm:mb-12" style={{
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '100%',
        letterSpacing: '0.2em'
      }}>{section.title}</h3>
      
      {/* MOBILE: Stack vertically, TABLET: 2 columns, DESKTOP: 3 columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 xl:gap-16 justify-items-center items-start">
        {/* Left Stylist - Full width on mobile */}
        <div className="w-full flex justify-center md:justify-end lg:justify-center">
          {renderStylist(section.stylists[0])}
        </div>
        
        {/* Center Image with consultation note below - Full width on mobile, spans 2 cols on tablet */}
        <div className="w-full md:col-span-2 lg:col-span-1 flex flex-col items-center">
          <div className="w-full max-w-[511px]">
            <img
              src={section.centerImage}
              alt={`${section.title} showcase`}
              className="w-full h-auto object-cover"
              style={{ aspectRatio: '511/766' }}
            />
          </div>
          
          {/* Consultation note below center image */}
          <p className="mt-4 text-center" style={{
            color: '#C7A064',
            fontFamily: 'Montserrat',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '100%',
            letterSpacing: '0.8px',
            textTransform: 'uppercase'
          }}>
            *PRICE UPON CONSULTATION
          </p>
        </div>
        
        {/* Right Stylist - Full width on mobile */}
        <div className="w-full flex justify-center md:justify-start lg:justify-center md:col-start-2 lg:col-start-auto">
          {renderStylist(section.stylists[1])}
        </div>
      </div>
    </div>
  </section>
))}

{/* MASTER STYLISTS SECTION - SIDE IMAGES LAYOUT */}
{renderSideImagesSection(sections[2])}

{/* STYLIST SECTION - SIDE IMAGES LAYOUT */}
{renderSideImagesSection(sections[3])}
    </>
  );
};

export default ServicesSection;